<template>
  <div>
    <highcharts ref="chart" :options="options"></highcharts>
  </div>
</template>

<script>
import '@/plugins/highcharts.js'
import { outliersDetection } from '@/mixins/outliersDetection'

export default {
  name: 'OutliersBoxPlot',
  mixins: [outliersDetection],
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    },
    log: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    yAxisTitle () {
      if (this.log) {
        return this.$t('compGraphicsOutliersBoxPlot.label-5')
      } else {
        return this.$t('compGraphicsOutliersBoxPlot.label-4')
      }
    }
  },
  data () {
    return {
      low: 999999999999999,
      q1: 0,
      median: 0,
      q3: 0,
      high: 0,
      options: {
        chart: {
          type: 'boxplot'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        series: [
          {
            name: this.$t('commutes'),
            color: 'black',
            data: []
          },
          {
            name: this.$t('compGraphicsOutliersBoxPlot.label-1'),
            color: 'red',
            type: 'scatter',
            marker: {
              symbol: 'circle'
            },
            data: [],
            tooltip: {
              pointFormat:
                '<strong>' +
                this.$t('compGraphicsOutliersBoxPlot.label-2') +
                ' {point.metadata}</strong>: {point.km} km'
            }
          },
          {
            name: this.$t('compGraphicsOutliersBoxPlot.label-3'),
            color: 'black',
            type: 'scatter',
            data: [],
            marker: {
              symbol: 'circle'
            },
            tooltip: {
              pointFormat:
                '<strong>' +
                this.$t('compGraphicsOutliersBoxPlot.label-2') +
                ' {point.metadata}</strong>: {point.km} km'
            }
          }
        ],
        yAxis: {
          min: 0,
          title: {
            text: this.yAxisTitle
          }
        },
        xAxis: {
          categories: ['', '2', '3', '4', '5']
        },
        exporting: {
          enabled: false
        }
      }
    }
  },
  methods: {
    randomValue () {
      let min = -500
      let max = 500
      let randomValue = Math.floor(Math.random() * (max - min + 1) + min)
      return Math.round((randomValue / 5000) * 100) / 100
    }
  },
  mounted () {
    let mdata = []
    this.detectOutliers(this.data.map((obj) => obj.distance))
    let outliersData = []
    let othersData = []
    for (let val of this.data) {
      let logVal = Math.log(val.distance + 1)
      if (logVal > this.high) {
        this.high = logVal
      }
      if (logVal < this.low) {
        this.low = logVal
      }
      let randX = this.randomValue()
      if (this.isOutlier(val.distance)) {
        if (this.log) {
          outliersData.push({
            x: randX,
            y: logVal,
            metadata: val.seqID,
            km: val.distance
          })
        } else {
          outliersData.push({
            x: randX,
            y: val.distance,
            metadata: val.seqID,
            km: val.distance
          })
        }
      } else {
        if (this.log) {
          mdata.push(logVal)
          othersData.push({
            x: randX,
            y: logVal,
            metadata: val.seqID,
            km: val.distance
          })
        } else {
          mdata.push(val.distance)
          othersData.push({
            x: randX,
            y: val.distance,
            metadata: val.seqID,
            km: val.distance
          })
        }
      }
    }
    this.options.series[0].data = [
      [
        Math.round(Math.min(...mdata) * 100) / 100,
        Math.round(this.quantile(mdata, 0.25) * 100) / 100,
        Math.round(this.quantile(mdata, 0.5) * 100) / 100,
        Math.round(this.quantile(mdata, 0.75) * 100) / 100,
        Math.round(Math.max(...mdata) * 100) / 100
      ]
    ]
    this.options.series[1].data = outliersData
    this.options.series[2].data = othersData
    if (this.log) {
      this.options.yAxis['plotLines'] = [
        {
          value: this.upperLim,
          color: 'red',
          width: 1,
          dashStyle: 'ShortDash',
          label: {
            text: 'q3 + 3 × (q3 - q1)',
            align: 'left',
            style: {
              color: 'red'
            }
          }
        },
        {
          value: this.lowerLim,
          color: 'red',
          width: 1,
          dashStyle: 'ShortDash',
          label: {
            text: 'q1 - 3 × (q3 - q1)',
            align: 'left',
            style: {
              color: 'red'
            }
          }
        }
      ]
      this.options.yAxis['min'] = Math.min(this.low, this.lowerLim) - 1
      this.options.yAxis['max'] = Math.max(this.high, this.upperLim) + 1
      this.options.yAxis['startOnTick'] = false
    }
    this.$refs.chart.chart.redraw()
  }
}
</script>
